angular.module("ainapp")
    .controller("leaveListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            $scope.PageName = "Leave List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                    IsLinkPending: false,
                };
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        //                        o.data.Keyword = $scope.filter.Keyword;
                        //                        o.data.IsLinkPending = $scope.filter.IsLinkPending;
                        MainService.LeaveApplicationsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            FromDate: {
                                type: "date",
                            },
                            ToDate: {
                                type: "date",
                            },
                            RefNo: {
                                type: "string",
                            },
                            AssignedLeaves: {
                                type: "number",
                            },
                            AvailableLeaves: {
                                type: "number",
                            },
                            NoOfDays: {
                                type: "number",
                            },
                            Remarks: {
                                type: "string",
                            },
                            Status: {
                                type: "string",
                            },
                            Reason: {
                                type: "string",
                            },
                            StatusNo: {
                                type: "number",
                            },
                            "ApprovedBy.UserName": {
                                type: "string",
                            },
                            "Employee.Name": {
                                type: "string",
                            },
                            "PayrollComponent.Name": {
                                type: "string",
                            },



                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [
                    {
                        field: "RefNo",
                        title: "#",
                    },
                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                                            },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                                            },
                    {
                        field: "PayrollComponent.Name",
                        title: "Component",
                                            },
                    {
                        field: "FromDate",
                        template: "#= kendo.toString(kendo.parseDate(FromDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "From Date",
                                            },
                    {
                        field: "ToDate",
                        template: "#= kendo.toString(kendo.parseDate(ToDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "From Date",
                                            },

                    {
                        field: "AssignedLeaves",
                        title: "Assigned Leaves",
                    },
                    {
                        field: "AvailableLeaves",
                        title: "Available Leaves",
                    },
                    {
                        field: "NoOfDays",
                        title: "No Of Days ",
                    },
                    {
                        field: "Remarks",
                        title: "Remarks",
                    },
                    {
                        field: "Status",
                        title: "Status",
                                            },
                    {
                        field: "Reason",
                        title: "Reason",
                                            },
                    {
                        field: "ApprovedBy.UserName",
                        title: "Processed By",
                                            },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button ng-if='dataItem.StatusNo  == 0' class=' btn-default btn-sm fa fa-pencil' ng-click='Approve(dataItem)'> Approve</button> <button ng-if='dataItem.StatusNo  == 0' class=' btn-default btn-sm fa fa-pencil' ng-click='Reject(dataItem)'> Reject</button> ",
                        width: '80px'
                        },


                                        ],
            };


            $scope.Edit = function (data) {
                $state.go("editSalesEnquiry", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }

            $scope.SelectedDataForApprove = {};
            $scope.Approve = function (data) {
                $scope.SelectedDataForApprove = data;
                $('#approveModal').modal('show');
            }

            $scope.SelectedDataForReject = {};
            $scope.Reject = function (data) {
                $scope.SelectedDataForReject = data;
                $('#rejectModal').modal('show');
            }

            $scope.approveWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ApproveLeaveApplcation($scope.SelectedDataForApprove.Id).then(function (response) {
                    if (response) {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                        $('#approveModal').modal('hide');
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.rejectWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.RejectLeaveApplcation($scope.SelectedDataForReject).then(function (response) {
                    if (response) {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                        $('#rejectModal').modal('hide');
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Print = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteSalesEnquiry($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response) {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.View = function (data) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    // $state.go("viewSalesEnquiry", {
                    //     VoucherId: data.Id
                    // })

                    var url = $state.href('viewSalesEnquiry', {
                        VoucherId: data.Id
                    });
                    window.open(url, '_blank');
                }
            }


                }])
